<template>
  <div class="checkout-builder-header">
    <div class="d-flex flex-lg-row flex-column align-items-center">
      <div class="back-container">
        <snow-button
          color="neutral"
          variant="outline"
          icon="ph ph-caret-left"
          text="Sair"
          @click="
            $router.push({
              name: 'product-details',
              params: { id: $route.params.id }
            })
          "
        />
        <snow-button
          :disabled="snapshots.length < 1"
          variant="borderless"
          icon="ph ph-arrow-u-up-left"
          @click="undoSnapshot"
        />

        <div class="d-lg-none d-flex gap-2">
          <snow-button
            icon="ph ph-desktop"
            :variant="device == 'desktop' ? 'gray' : 'borderless'"
            @click="setDevice('desktop')"
          />
          <snow-button
            icon="ph ph-device-mobile-camera"
            :variant="device == 'mobile' ? 'gray' : 'borderless'"
            @click="setDevice('mobile')"
          />
        </div>
      </div>

      <div class="flex-fill d-flex justify-content-end gap-2">
        <div class="d-lg-flex d-none gap-2">
          <snow-button
            icon="ph ph-desktop"
            :variant="device == 'desktop' ? 'gray' : 'borderless'"
            @click="setDevice('desktop')"
          />
          <snow-button
            icon="ph ph-device-mobile-camera"
            :variant="device == 'mobile' ? 'gray' : 'borderless'"
            @click="setDevice('mobile')"
          />
        </div>
        <snow-button
          v-if="editing"
          variant="outline"
          class="d-lg-none"
          icon="ph ph-gear"
          @click="menuModal = true"
        />
        <snow-button
          variant="outline"
          :text="editing ? 'Visualizar' : 'Editar'"
          @click="toggleEditing"
        />
        <snow-button
          text="Salvar checkout"
          :loading="loading"
          :disabled="!snapshots.length"
          @click="save"
        />
      </div>
    </div>
    <responsive-modal v-model="menuModal">
      <settings-menu />
    </responsive-modal>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import SettingsMenu from "./SettingsMenu.vue";
export default {
  components: { SettingsMenu },
  data() {
    return {
      loading: false,
      menuModal: false
    };
  },
  computed: {
    ...mapState("checkoutBuilder", [
      "device",
      "editing",
      "checkoutBuilder",
      "background",
      "components",
      "snapshots",
      "editing"
    ])
  },
  methods: {
    setDevice(device) {
      this.$store.commit("checkoutBuilder/setDevice", device);
    },
    toggleEditing() {
      this.$store.commit("checkoutBuilder/setEditing", !this.editing);
    },
    async save() {
      const checkout = { ...this.checkoutBuilder, title: "checkout" };
      let components = [...this.components];

      let action = "checkoutBuilder/put";
      if (!checkout.id) {
        delete checkout.id;
        action = "checkoutBuilder/post";
        checkout.product_id = this.$route.params.id;
      }

      checkout.config = {
        ...checkout.config,
        textColor: "unset",
        longPage: !!checkout.config?.longPage
      };
      checkout.type = "custom";

      checkout.background_image = this.background.image || null;
      checkout.config.backgroundColor = this.background.color;

      const timer = components.find(c => c.type == "timer" && !c.deleted);
      checkout.config.countdown = !!timer;
      if (timer) {
        delete timer["type"];
        components = components.filter(c => c.type != "timer");
        checkout.config = {
          ...checkout.config,
          ...timer
        };
      }
      const deletedComponents = components.filter(c => c.deleted && c.id > 0);

      checkout.components = components
        .filter(c => !c.deleted && !c.countdown)
        .map(c => ({
          ...c,
          ...(checkout.id ? { checkout_build: checkout.id } : {}),
          config: {
            ...c.config,
            "padding-left": "unset",
            "padding-right": "unset",
            "padding-top": "unset",
            "padding-bottom": "unset",
            "margin-top": "unset",
            "margin-bottom": "unset",
            "border-radius": "4px"
          }
        }));

      this.loading = true;

      try {
        await Promise.all(
          deletedComponents.map(c =>
            this.$store.dispatch("checkoutBuilder/deleteComponent", c.id)
          )
        );
        setTimeout(() => {
          this.$store
            .dispatch(action, checkout)
            .then(({ data }) => {
              this.$store.dispatch("checkoutBuilder/setCheckoutState", data);
            })
            .then(() => {
              this.$message.success("Checkout salvo!");
              this.$store.commit("checkoutBuilder/setSnapshots", []);
            })
            .finally(() => (this.loading = false));
        }, 500);
      } catch (error) {
        this.$message.error("Erro ao salvar checkout.");
      }
    },
    ...mapActions("checkoutBuilder", ["undoSnapshot"])
  }
};
</script>

<style lang="scss" scoped>
.checkout-builder-header {
  padding: 16px 28px;
  min-height: 72px;
  position: relative;
  border-bottom: 1px solid var(--dark-10);

  .back-container {
    display: flex;
    gap: 28px;
  }

  @media screen and (max-width: 991px) {
    border-bottom: none;
    padding: 16px 16px;
    .back-container {
      width: 100%;
      justify-content: space-between;
      gap: 12px;
      margin-bottom: 28px;
    }
  }
}
</style>
